import { render, staticRenderFns } from "./contact-form-container.vue?vue&type=template&id=b256fde4&scoped=true&"
import script from "./contact-form-container.vue?vue&type=script&lang=js&"
export * from "./contact-form-container.vue?vue&type=script&lang=js&"
import style0 from "./contact-form-container.vue?vue&type=style&index=0&id=b256fde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b256fde4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b256fde4')) {
      api.createRecord('b256fde4', component.options)
    } else {
      api.reload('b256fde4', component.options)
    }
    module.hot.accept("./contact-form-container.vue?vue&type=template&id=b256fde4&scoped=true&", function () {
      api.rerender('b256fde4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/contact-form-container.vue"
export default component.exports